import type { TInputAutocomplete } from './models';

export const checkShow = ({
    list,
    value,
}: Required<Pick<TInputAutocomplete, 'list' | 'value'>>) => {
    if (list.length === 1 && list[0].toLowerCase() === String(value).toLowerCase()) {
        return false;
    }

    return true;
};
